import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { Entity, Person, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ComponentPropsProvider, ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayoutProps, ExplorerProviders, ExplorerTabs, GridLoader, SiteHeaderLayout, SiteHeaderProvider } from '@shapeable/ui';

const cls = classNames('entity-explorer-layout');

// -------- Types -------->

// -------- Props -------->

export type TrendsExplorerLayoutProps = ExplorerEntityDetailsLayoutProps & { 
  entity: Entity;
  loading?: boolean;
};

export const TrendsExplorerLayoutDefaultProps: Omit<TrendsExplorerLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

type LayoutProps = {
  labelColor?: string;
}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    .shp--entity-banner {
     .shp--cell-label {  
        color: ${({ labelColor }: LayoutProps) => labelColor }
     }
    }
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    
  `,
});


const LoaderStyles = breakpoints({
  base: css`
    min-height: calc(100vh - 330px);
  `,
});


const TabsStyles = breakpoints({
  base: css`
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)<LayoutProps>`${LayoutStyles}`,
      Tabs: styled(ExplorerTabs)`${TabsStyles}`,

    Loader: styled(GridLoader)`${LoaderStyles}`,
};

export const TrendsExplorerLayout: Shapeable.FC<TrendsExplorerLayoutProps> = (props) => {
  const { className, entity, loading, ...rest } = props;

  const hasBannerImage = !!entity?.banner || !!entity?.banners?.length;

  return (
    <ExplorerProviders>
    <SiteHeaderProvider
      value={{
        variant: 'default',
    }}>
    <ComponentPropsProvider value={{
      EntityBanner: {
        maxHeight: 300,
        fontTypes: { header: 'heading' },
        variant: hasBannerImage ? 'image' : 'color',
        showSubheader: true,
        useBackgroundColor: !hasBannerImage,
        entityValueProps: { 
          showImage: false, 
          showOutlineNumber: false, 
          
        }
      }
    }}>
    <My.Container>
      <My.Header />
      <My.Tabs useStickyStyle />
      {
        loading ?
        <My.Loader /> :
        <My.Layout 
          {...rest}
          labelColor={hasBannerImage ? 'text': 'canvas'}
          stickyTopOffset={110}
          showAsideHeader={false}
          entity={entity}
          className={cls.name(className)}
          isAsideSticky={false}

          // dataVizHeadMain={

          // }
        />
      }
    </My.Container>
    </ComponentPropsProvider>
    </SiteHeaderProvider>
    </ExplorerProviders>
  )
};

export const TrendsExplorerLayoutWithoutBanner: React.FC<TrendsExplorerLayoutProps> = (props) => <TrendsExplorerLayout {...props} showBanner={false} />;

TrendsExplorerLayout.defaultProps = TrendsExplorerLayoutDefaultProps;
TrendsExplorerLayout.cls = cls;